export default __webpack_public_path__ + "static/media/domain-white.71afba85.svg";